<template>
    <div id="top_menu" style="margin: 1rem 0;">
        <!-- <router-link :to="{name: 'provider_index'}"
            :class="'item'"
            :style="{display: (window_width < 600) ? 'none' : ''}"
            v-if="!$store.getters['provider/is_current_staff_minimalist_layout']">
            <img style="height: 70px; width: auto;"
                :src="'/images/'+$store.state.provider.service_config.logo_img"
            >
        </router-link> -->
        <div class="menus" style="text-align: right;">
            <div class="ui compact menu">
                <div class="item" v-if="show_receipts" :data-tooltip="$t('ui.links.top_menu.my_receipts')" data-position="bottom center">
                    <MyReceipts></MyReceipts>
                </div>

                <div class="item" v-if="show_check_summary" :data-tooltip="$t('ui.links.top_menu.print_check_summary')"  data-position="bottom center">
                    <CheckSummary></CheckSummary>
                </div>

                <div class="item mobile hidden" v-if="is_can_use_scanner" :data-tooltip="$t('ui.links.top_menu.scanner') + '（' + $t('ui.general.hot_key')+'：Ctrl + Q）'"  data-position="bottom center">
                    <div class="ui icon button"
                        @click="$bus.$emit('toggle_scanner_modal', 'show')">
                        <i class="barcode large icon"></i>
                    </div>
                </div>
                <div class="item" v-else :data-tooltip="$t('ui.general.cannot_use')" data-position="bottom center">
                    <div class="ui icon button">
                        <i class="red barcode large icon"></i>
                    </div>
                </div>
            </div>
            <div class="ui compact menu">
                <div class="item">
                    <Notifications :channel_identity="channel_identity"></Notifications>
                </div>
                <div class="item" :data-tooltip="$t('ui.links.top_menu.language')"  data-position="bottom center">
                    <div class="ui icon dropdown top right pointing button" v-dropdown>
                        <i class="globe large icon"></i>
                        <div class="menu">
                            <a class="item" @click="change_i18n('zh-TW')">繁體</a>
                            <a class="item" @click="change_i18n('zh-CN')">简体</a>
                            <a class="item" @click="change_i18n('ja-JP')">日本語</a>
                            <a class="item" @click="change_i18n('ko-KR')">한국어</a>
                            <a class="item" @click="change_i18n('en-US')">English</a>
                            <a class="item" @click="change_i18n('de-DE')">Deutsch</a>
                            <a class="item" @click="change_i18n('es-ES')">Español</a>
                            <a class="item" @click="change_i18n('vi-VN')">Tiếng Việt</a>
                            <a class="item" @click="change_i18n('km-KH')">ភាសាខ្មែរ</a>
                        </div>
                    </div>
                </div>
                <div class="item" style="">
                    <div class="ui icon dropdown top right pointing button" v-dropdown>
                        <i class="setting large icon"></i>
                        <div class="menu">
                            <div class="header">
                                {{ current_staff.name }}
                            </div>
                            <a class="item" @click="$parent.show_login_timeout_hint">
                                {{ $t('ui.links.top_menu.overtime_note') }}
                            </a>
                            <a class="item" @click="$parent.logout">
                                {{ $t('ui.links.top_menu.logout') }}
                            </a>
                            <a class="item" @click="$parent.logout(true)">
                                {{ $t('ui.links.top_menu.full_logout') }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <SpeedTest></SpeedTest>
                </div>
            </div>
        </div>

        <div class="clear"></div>
    </div>
</template>

<script>
import SpeedTest from "@toolbox/speed_test/main.vue"
import MyReceipts from "./my_receipts.vue"
import Notifications from "@toolbox/notifications/main.vue"
import CheckSummary from "./check_summary.vue"
export default {
    data() {
        return {
            window_width: $(window).width()
        }
    },
    mounted() {
        $(window).resize(() => {
            this.window_width = $(window).width()
        });

        $(document).ready(() => {
            var stations = {}

            $(document).delegate('.quick_link_select .menu .item', 'click', (event) => {
                window.location = $(this).data('url')
            });

            $(document).delegate('.current_station_select .menu .item', 'click', (event) => {
                var identity = $(this).data('value')
                var name = $(this).text()
            });
        });
    },
    computed: {
        current_staff() {
            return this.$store.state.provider.current_staff
        },
        is_can_use_scanner() {
            return this.$store.state.provider.is_can_use_scanner
        },
        current_service_name() {
            return this.$store.state.provider.node.service_name
        },
        channel_identity() {
            return this.$store.state.provider.node.identity
        },
        show_receipts() {
            return ["neuron_premium", "neuron", "neuron_lite"].includes(this.current_service_name)
        },
        show_check_summary() {
            return ["neuron_premium", "axon_premium", "axon", "axon_lite"].includes(this.current_service_name)
        },
    },
    methods: {
        change_i18n(language = "zh-TW") {
            localStorage.setItem("language", language)
            this.$store.state.language = language
        },
    },
    components: {
        SpeedTest,
        MyReceipts,
        Notifications,
        CheckSummary,
    }
}
</script>

<style scoped lang="scss">
    @media only screen and (max-width: 640px) {
        .ui.menu {
            .right.menu {
                flex-wrap: wrap;
            }
        }
    }
    .ui.menu .item:before {
        width: 0;
    }

    .menus .compact.menu {
        &:first-child div.item,
        &:last-child div.item:not(:last-child) {
            width: 55px;
            height: 55px;
            padding: .5em;
        }
        &:first-child,
        &:first-child div.item:last-child {
            margin-right: .5em;
        }
        &:last-child div.item:nth-last-child(2) {
            padding: .5em 0 .5em .5em;
        }
    }
</style>
<style lang="scss">
#top_menu .compact.menu .menu.transition {
    max-height: 30em;
    overflow-x: hidden;
    overflow-y: auto;
}
@media only screen and (max-width: 420px) {
    #top_menu .compact.menu {
        &:first-child {
            margin: 0 .2em;
        }
        &:first-child div.item:last-child {
            margin-right: 1.4em;
        }
        div.item .button {
            padding: .5em;
        }
        &:first-child div.item,
        &:last-child div.item:not(:last-child) {
            width: 35px;
            height: 35px;
            margin: .3em;
        }
    }
}
@media only screen and (max-width: 360px) {
    #top_menu .compact.menu {
        &:first-child div.item,
        &:last-child div.item:not(:last-child) {
            width: 30px;
            height: 30px;
            margin: .4em;
        }
        &:last-child div.item:last-child {
            margin: 0.1em;
            padding: 0 .3em 0 1em;
        }
    }
}
</style>
